import React from 'react';
import { auth } from './../../helper/helperFirebaseAuth';
import { onAuthStateChanged } from 'firebase/auth';


const UserContext = React.createContext();


export const AuthProvider = ({ children }) => {
    const [authUser, setAuthUser] = React.useState(null);
    const [authLoading, setAuthLoading] = React.useState(true);

    React.useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const idTokenResult = await user.getIdTokenResult();
                const userWithClaims = {
                    ...user,
                    isSuperAdmin: idTokenResult?.claims?.isSuperAdmin || false,
                };
                setAuthUser(userWithClaims);
            } else {
                setAuthUser(null);
            }
            setAuthLoading(false);
        });
        return () => unsubscribe();
    }, []);

    return (
        <UserContext.Provider value={{ authUser, authLoading }}>
            {children}
        </UserContext.Provider>
    );
};

export const useAuth = () => React.useContext(UserContext);